import { useState } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import RelatedPages from '@/components/base/RelatedPages';
import ServiceSubNav from '@/components/base/ServiceSubNav';

const SERVICE_SUBNAV_ITEMS = [
  { label: '熱销配方', path: '/services/hot-formulas' },
  { label: '天然原料', path: '/services/natural-ingredients' },
  { label: '各類劑型', path: '/services/dosage-forms' },
  { label: '包裝設計', path: '/services/packaging' },
];

const formulas = [
  {
    id: 1,
    icon: 'ri-heart-line',
    title: '天然美肌',
    desc: '以膠原蛋白、透明質酸鈉 、維生素 C 等天然成分為核心，由內而外維持肌膚水潤光澤',
    tags: ['膠原蛋白', '透明質酸鈉', '維生素 C', '植物萃取'],
    dosages: ['粉劑', '果凍條', '膠囊錠劑'],
    color: '#f48fb1',
    img: 'https://readdy.ai/api/search-image?query=natural%20beauty%20supplement%20collagen%20hyaluronic%20acid%20skincare%20product%20with%20rose%20petals%20white%20background%20elegant%20feminine%20packaging%20health%20beauty%20photography&width=400&height=300&seq=hf-beauty-01&orientation=landscape',
  },
  {
    id: 2,
    icon: 'ri-sparkling-line',
    title: '女性私密',
    desc: '結合乳酸菌、蔓越莓萃取等成分，維持女性私密部位健康環境，舒適安心。',
    tags: ['乳酸菌', '蔓越莓', '益生菌'],
    dosages: ['粉劑', '膠囊', '錠劑', '果凍'],
    color: '#ce93d8',
    img: 'https://readdy.ai/api/search-image?query=feminine%20health%20supplement%20probiotic%20cranberry%20extract%20product%20soft%20pastel%20purple%20pink%20background%20elegant%20women%20health%20care%20packaging&width=400&height=300&seq=hf-fem-01&orientation=landscape',
  },
  {
    id: 3,
    icon: 'ri-men-line',
    title: '男性魅力',
    desc: '精選馬卡萃取、酵母鋅、精胺酸 等成分，支持男性活力與體能， 從內調整狀態',
    tags: ['馬卡', '酵母鋅', '精胺酸'],
    dosages: ['粉劑', '膠囊', '錠劑', '果凍'],
    color: '#90caf9',
    img: 'https://readdy.ai/api/search-image?query=mens%20health%20supplement%20maca%20oyster%20extract%20zinc%20vitality%20product%20dark%20masculine%20packaging%20on%20clean%20white%20background%20professional%20health%20photography&width=400&height=300&seq=hf-men-01&orientation=landscape',
  },
  {
    id: 4,
    icon: 'ri-leaf-line',
    title: '順暢輕盈',
    desc: '益生菌、膳食纖維、酵素複合配方，幫助維持腸道菌叢平衡，天天輕盈順暢',
    tags: ['益生菌', '膳食纖維', '酵素'],
    dosages: ['粉劑', '膠囊', '錠劑', '果凍'],
    color: '#a5d6a7',
    img: 'https://readdy.ai/api/search-image?query=digestive%20health%20probiotic%20fiber%20supplement%20green%20fresh%20natural%20ingredients%20gut%20health%20product%20on%20light%20background%20clean%20minimal%20photography&width=400&height=300&seq=hf-digest-01&orientation=landscape',
  },
  {
    id: 5,
    icon: 'ri-eye-line',
    title: '水潤晶亮',
    desc: '以葉黃素、玉米黃素為主配方，搭配植物萃取保養配方，全方位守護眼睛健康',
    tags: ['葉黃素', '玉米黃素', '植物萃取'],
    dosages: ['粉劑', '膠囊', '錠劑', '果凍'],
    color: '#80deea',
    img: 'https://readdy.ai/api/search-image?query=eye%20health%20supplement%20lutein%20zeaxanthin%20blueberry%20extract%20product%20on%20light%20background%20healthy%20vision%20care%20product%20photography%20natural%20light&width=400&height=300&seq=hf-eye-01&orientation=landscape',
  },
  {
    id: 6,
    icon: 'ri-riding-line',
    title: '健身助力',
    desc: '多樣動、植物性蛋白搭配支鏈胺基酸( BCAA)，幫助肌肉修復、提供運動後補給',
    tags: ['動、植物性高蛋白', '支鏈胺基酸'],
    dosages: ['粉劑'],
    color: '#ffe082',
    img: 'https://readdy.ai/api/search-image?query=sports%20nutrition%20supplement%20BCAA%20protein%20powder%20workout%20fitness%20product%20on%20dark%20sporty%20background%2C%20health%20bodybuilding%20supplement%20professional%20photography&width=400&height=300&seq=hf-sport-01&orientation=landscape',
  },
  {
    id: 7,
    icon: 'ri-moon-line',
    title: '好眠好夢',
    desc: '天然植物萃取、GABA 、礦物質等配方 ，有助於放鬆身心，提升睡眠品質',
    tags: ['植物萃取', 'GABA', '礦物質'],
    dosages: ['粉劑', '膠囊', '錠劑', '果凍'],
    color: '#b39ddb',
    img: 'https://readdy.ai/api/search-image?query=sleep%20supplement%20GABA%20valerian%20L-theanine%20natural%20sleep%20aid%20product%20lavender%20purple%20background%20calm%20relaxation%20health%20photography&width=400&height=300&seq=hf-sleep-01&orientation=landscape',
  },
  {
    id: 8,
    icon: 'ri-run-line',
    title: '關鍵骨力',
    desc: '鈣質、膠原蛋白、維生素D 等成分 ，有助強化骨骼關節健康 適合中、老年族群',
    tags: ['礦物質', '維生素D', '膠原蛋白'],
    dosages: ['粉劑', '膠囊', '錠劑', '果凍'],
    color: '#bcaaa4',
    img: 'https://readdy.ai/api/search-image?query=bone%20joint%20health%20supplement%20calcium%20magnesium%20vitamin%20D%20glucosamine%20product%20on%20white%20background%2C%20strong%20healthy%20bones%20concept%20photography&width=400&height=300&seq=hf-bone-01&orientation=landscape',
  },
  {
    id: 9,
    icon: 'ri-seedling-line',
    title: '頂上煩惱',
    desc: '生物素、何首烏萃取、黑芝麻等配方，從根本穩固頭髮健康，告別掉髮問題',
    tags: ['生物素', '何首烏', '黑芝麻'],
    dosages: ['粉劑', '膠囊', '錠劑', '果凍'],
    color: '#8d6e63',
    img: 'https://readdy.ai/api/search-image?query=hair%20health%20supplement%20biotin%20black%20sesame%20he%20shou%20wu%20product%20with%20natural%20herbs%20on%20clean%20white%20background%20elegant%20hair%20care%20product%20photography&width=400&height=300&seq=hf-hair-01&orientation=landscape',
  },
  {
    id: 10,
    icon: 'ri-emotion-happy-line',
    title: '兒童成長',
    desc: '鈣質、維生素、益生菌、蛋白質、植物萃取等兒童必須營養，口感佳、成分安全，支持兒童全面發展',
    tags: ['鈣質', '維生素', '益生菌', '蛋白質'],
    dosages: ['粉劑', '錠劑', '果凍條'],
    color: '#ffcc80',
    img: 'https://readdy.ai/api/search-image?query=children%20health%20supplement%20calcium%20DHA%20probiotic%20colorful%20fruit%20flavored%20vitamins%20for%20kids%20on%20bright%20cheerful%20background%2C%20safe%20natural%20ingredients&width=400&height=300&seq=hf-kids-01&orientation=landscape',
  },
  {
    id: 11,
    icon: 'ri-heart-pulse-line',
    title: '寶寶配方',
    desc: '嬰幼兒專屬配方，採用最溫和天然的原料，支持寶寶腸道健康與免疫力發展。',
    tags: ['嬰幼兒益生菌', '初乳', '維生素'],
    dosages: ['粉劑'],
    color: '#f8bbd0',
    img: 'https://readdy.ai/api/search-image?query=baby%20infant%20health%20supplement%20probiotic%20powder%20gentle%20natural%20formula%20for%20newborn%20toddler%20on%20soft%20pastel%20pink%20white%20background%20gentle%20photography&width=400&height=300&seq=hf-baby-01&orientation=landscape',
  },
  {
    id: 12,
    icon: 'ri-scales-3-line',
    title: '窈窕纖美',
    desc: '藤黃果萃取、白腎豆、綠咖啡萃取等天然成分，協助維持體重管理，搭配健康生活更有效。',
    tags: ['藤黃果', '白腎豆', '綠咖啡豆'],
    dosages: ['粉劑', '錠劑', '膠囊', '果凍'],
    color: '#c8e6c9',
    img: 'https://readdy.ai/api/search-image?query=weight%20management%20slim%20supplement%20green%20coffee%20white%20kidney%20bean%20garcinia%20cambogia%20product%20on%20clean%20fresh%20green%20white%20background%20healthy%20slimming%20photography&width=400&height=300&seq=hf-slim-01&orientation=landscape',
  },
  {
    id: 13,
    icon: 'ri-sun-line',
    title: '日常營養',
    desc: '維生素、蛋白質、礦物質、植物萃取，複合型、單種營養型營養，針對不同族群需求作調配，維持日常基礎營養需求',
    tags: ['維生素', '蛋白質', '礦物質', '植物萃取'],
    dosages: ['粉劑', '錠劑', '膠囊', '果凍'],
    color: '#fff59d',
    img: 'https://readdy.ai/api/search-image?query=multivitamin%20daily%20nutrition%20supplement%20colorful%20capsules%20tablets%20minerals%20vitamins%20on%20white%20background%20fresh%20healthy%20lifestyle%20concept%20photography&width=400&height=300&seq=hf-daily-01&orientation=landscape',
  },
  {
    id: 14,
    icon: 'ri-bear-smile-line',
    title: '毛孩專屬',
    desc: '針對毛孩犬、貓、兔 設計的保健配方 ，符合飼料添加物法規，讓毛孩也能 守護健康',
    tags: ['益生菌', '膠原蛋白', '魚油', '植物萃取'],
    dosages: ['粉劑', '錠劑'],
    color: '#bcaaa4',
    img: 'https://readdy.ai/api/search-image?query=pet%20health%20supplement%20dog%20cat%20natural%20organic%20probiotic%20omega3%20joint%20care%20product%20with%20cute%20pet%20imagery%20on%20light%20background%20natural%20health%20photography&width=400&height=300&seq=hf-pet-01&orientation=landscape',
  },
  {
    id: 15,
    icon: 'ri-mental-health-line',
    title: '安心凝神',
    desc: '益生菌、維生素、礦物質、植物萃取等成分，有助於維持專注力與情緒穩定，為您調解生活上的壓力',
    tags: ['益生菌', '維生素', '礦物質', '植物萃取'],
    dosages: ['粉劑', '錠劑', '膠囊', '果凍'],
    color: '#b2dfdb',
    img: 'https://readdy.ai/api/search-image?query=brain%20health%20focus%20supplement%20phosphatidylserine%20DHA%20B%20vitamins%20cognitive%20function%20product%20on%20calm%20blue%20green%20background%20mental%20wellness%20photography&width=400&height=300&seq=hf-brain-01&orientation=landscape',
  },
  {
    id: 16,
    icon: 'ri-shield-star-line',
    title: '強力防護',
    desc: '維生素、益生菌、植物萃取、蛋白等天然配方，全面強化身體防禦機制，支援免疫力',
    tags: ['維生素', '益生菌', '植物萃取', '蛋白'],
    dosages: ['粉劑', '錠劑', '膠囊'],
    color: '#a5d6a7',
    img: 'https://readdy.ai/api/search-image?query=immune%20health%20supplement%20vitamin%20C%20zinc%20elderberry%20lactoferrin%20shield%20protection%20product%20on%20fresh%20green%20white%20background%20healthy%20immunity%20photography&width=400&height=300&seq=hf-immune-01&orientation=landscape',
  },
  {
    id: 17,
    icon: 'ri-bug-2-line',
    title: '好菌加倍',
    desc: '多樣種類益生菌，提供體內擁有多樣、完整的菌群，維持體內多樣機能健康運作',
    tags: ['益生菌', '益生元', '益生質'],
    dosages: ['粉劑', '錠劑', '膠囊', '果凍'],
    color: '#ffe0b2',
    img: 'https://readdy.ai/api/search-image?query=probiotic%20supplement%20multiple%20strains%20lactobacillus%20product%20with%20clean%20fresh%20natural%20background%20white%20green%20gut%20microbiome%20health%20photography&width=400&height=300&seq=hf-probiotic-01&orientation=landscape',
  },
];

export default function HotFormulasContent() {
  const [expanded, setExpanded] = useState<number | null>(null);

  return (
    <>
      {/* Hero */}
      <section className="relative pt-20 min-h-[360px] md:min-h-[420px] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=diverse%20collection%20of%20colorful%20health%20supplement%20products%20capsules%20powders%20gummies%20arranged%20beautifully%20on%20white%20marble%20surface%2C%20vibrant%20natural%20ingredients%20visible%2C%20professional%20product%20display%20photography&width=1920&height=420&seq=hf-hero-bg-01&orientation=landscape"
            alt="熱銷配方背景"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1a3a1a]/90 via-[#1a3a1a]/65 to-[#1a3a1a]/20" />
        </div>
        <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 lg:px-10 pb-14 pt-28">
          <div className="max-w-2xl">
            <Breadcrumb
              items={[
                { label: '首頁', href: '/' },
                { label: '代工服務', href: '/services' },
                { label: '熱銷配方' },
              ]}
              className="mb-4 text-gray-300"
            />
            <span className="inline-block bg-[#4CAF50]/25 border border-[#4CAF50]/50 text-green-300 text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5">
              代工服務
            </span>
            <h1 className="text-white font-bold text-[2.25rem] md:text-[2.875rem] leading-tight mb-4">
              熱銷配方
            </h1>
            <p className="text-gray-200 text-[1.0625rem] leading-[1.75] max-w-xl">
              依照不同族群、生活需求與市場趨勢，協助品牌規劃適合銷售通路的保健配方方向。
            </p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="bg-white border-b border-gray-100 py-5">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            {[
              { num: '17+', label: '配方種類' },
              { num: '1,000+', label: '累計代工品項' },
              { num: '7', label: '可選劑型' },
              { num: '250+', label: '服務品牌' },
            ].map((s) => (
              <div key={s.label}>
                <p className="text-[#4CAF50] font-bold text-[1.75rem] md:text-[2rem] leading-none mb-1">{s.num}</p>
                <p className="text-gray-500 text-[0.875rem]">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Formula grid */}
      <section className="py-20 bg-[#f7faf7]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
              配方總覽
            </span>
            <h2 className="text-[#1a2e1a] font-bold text-[1.75rem] md:text-[2.125rem] mb-4">
              17 大配方方向
            </h2>
            <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
              點擊配方卡片可展開詳細說明，找到最適合您品牌定位的配方方向
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {formulas.map((f) => (
              <div
                key={f.id}
                className={`bg-white rounded-2xl overflow-hidden border transition-all duration-300 cursor-pointer ${
                  expanded === f.id ? 'border-[#4CAF50]/50' : 'border-gray-100 hover:border-green-200 hover:-translate-y-1'
                }`}
                onClick={() => setExpanded(expanded === f.id ? null : f.id)}
              >
                {/* Image */}
                <div className="w-full h-[260px] overflow-hidden relative">
                  <img
                    src={f.img}
                    alt={f.title}
                    className="w-full h-full object-cover object-top transition-transform duration-300 hover:scale-105"
                  />
                  <div className="absolute top-3 right-3">
                    <div
                      className="w-8 h-8 flex items-center justify-center rounded-full"
                      style={{ backgroundColor: `${f.color}30` }}
                    >
                      <i className={`${f.icon} text-sm`} style={{ color: f.color }} />
                    </div>
                  </div>
                </div>

                {/* Basic info */}
                <div className="p-5">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-[#1a2e1a] font-bold text-[1.0625rem]">{f.title}</h3>
                    <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-200 flex-shrink-0 ${expanded === f.id ? 'bg-[#4CAF50] text-white' : 'bg-green-50 text-[#4CAF50]'}`}>
                      <i className={`text-xs ${expanded === f.id ? 'ri-subtract-line' : 'ri-add-line'}`} />
                    </div>
                  </div>
                  <p className="text-gray-500 text-[0.875rem] leading-[1.75] mb-3 line-clamp-2">{f.desc}</p>

                  {/* Dosage tags */}
                  <div className="flex flex-wrap gap-1.5">
                    {f.dosages.map((d) => (
                      <span key={d} className="bg-green-50 border border-green-100 text-[#4CAF50] text-[0.75rem] px-2.5 py-1 rounded-full font-medium">
                        {d}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Expanded detail */}
                {expanded === f.id && (
                  <div className="px-5 pb-5 border-t border-gray-100 pt-4">
                    <p className="text-gray-600 text-[0.875rem] leading-[1.75] mb-3">{f.desc}</p>
                    <div className="flex flex-wrap gap-1.5 mb-4">
                      {f.tags.map((tag) => (
                        <span key={tag} className="bg-[#f7faf7] border border-gray-200 text-gray-500 text-[0.75rem] px-2.5 py-1 rounded-full">
                          {tag}
                        </span>
                      ))}
                    </div>
                    <Link
                      to="/contact/form"
                      onClick={(e) => e.stopPropagation()}
                      className="whitespace-nowrap inline-flex items-center gap-1.5 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[0.8125rem] px-4 py-2 rounded-full transition-all duration-200 cursor-pointer"
                    >
                      洽詢此配方
                      <i className="ri-arrow-right-line text-xs" />
                    </Link>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 text-center">
          <h2 className="text-[#1a2e1a] font-bold text-[1.75rem] md:text-[2.125rem] leading-tight mb-4">
            沒找到合適的配方方向？
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-xl mx-auto mb-8">
            康永生技可依您的品牌定位與目標族群，量身打造全新配方方向，歡迎洽詢研發團隊。
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/contact/form"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-bold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              洽詢配方開發
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/services/dosage-forms"
              className="whitespace-nowrap inline-flex items-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white font-semibold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              查看各類劑型
            </Link>
          </div>
        </div>
      </section>
      <ServiceSubNav
        items={SERVICE_SUBNAV_ITEMS}
        backLabel="返回服務總覽"
        backPath="/services"
        sectionLabel="其他服務頁面"
      />
      <RelatedPages items={[
        { title: '天然原料', desc: '動物、植物、菇蕈、藻類油脂…了解康永嚴選原料的多元類別。', href: '/services/natural-ingredients' },
        { title: '各類劑型', desc: '膠囊、錠劑、粉劑、果凍條…選擇適合品牌定位的劑型。', href: '/services/dosage-forms' },
        { title: '立即洽詢', desc: '填寫諮詢表單，讓康永協助您打造熱銷品牌。', href: '/contact/form' },
      ]} />
    </>
  );
}
